<template>
  <section class="main">
    <div v-show="isLoading">
      <PageLoading />
    </div>
    <div v-show="!isLoading">
      <v-page-header :title="getPageTile" />

      <div v-show="hasLoadingError">
        <div class="grid-container">
          <p class="text-center">{{ loadingError }}</p>
        </div>
      </div>

      <div v-show="!hasLoadingError">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
              <div class="wrapper">
                <v-action-buttons :items="getActionButtons" />

                <div class="box">
                  <v-navigation />
                  <div class="grid-x">
                    <div class="cell small-12 medium-3">
                      <h2>{{ $t("projects.title") }}</h2>
                    </div>
                    <div class="cell small-12 medium-9">
                      <div class="projects-qm-count">
                        <template v-if="isCalculatingTotalQm">
                          <div class="loading-spinner-wrapper">
                            <PageLoading position="absolute" right/>
                          </div>
                        </template>

                        <template v-else>
                          <ul>
                            <li>
                              <template v-if="projectsTableItemsCount === 1">{{ $t('project.title') }}:</template>
                              <template v-else>{{ $t('projects.title') }}:</template>
                              <span>{{ $helpers.formatNumber(projectsTableItemsCount) }}</span>
                            </li>
                            <li>
                              {{ $t("projects.qm.total") }}
                              <span>{{ $helpers.formatNumber(projectsTotalQm) }}</span>
                              {{ $t("qm") }}
                            </li>
                            <li>
                              {{ $t("projects.qm.totalopen") }}
                              <span>{{ $helpers.formatNumber(projectsTotalOpenQm) }}</span>
                              {{ $t("qm") }}
                            </li>
                          </ul>
                        </template>
                        
                      </div>
                    </div>
                  </div>

                  <form
                    action
                    method="POST"
                    class="filter filter--search"
                    novalidation
                    @submit="onChangeProjectsTableFilter"
                  >
                      <div class="grid-x grid-padding-x align-middle align-right u-extra-small-margin--bottom" v-if="$store.getters.userIsAdmin">
                          <div class="cell small-auto medium-9 u-no-padding"><p class="u-no-margin text-right"><strong>Offene QM:</strong></p></div>
                          <div class="cell small-auto medium-3">
                              <div class="form-group form-group--row u-no-margin--bottom">
                                  <label for="form-field-minqm" class="u-no-margin--bottom text-right"> {{ $t('search.from') }}</label>
                                  <input
                                          type="number"
                                          inputmode="decimal"
                                          class="form-control form-control--small u-no-margin--bottom"
                                          id="form-field-minqm"
                                          name="minqm"
                                          :placeholder="$t('search.from')"
                                          v-model="projectsTableFilter.minqm"
                                  />
                                  <label for="form-field-maxqm" class="u-no-margin--bottom text-right">{{ $t('search.till') }}</label>
                                  <input
                                          type="number"
                                          inputmode="decimal"
                                          class="form-control form-control--small u-no-margin--bottom"
                                          id="form-field-maxqm"
                                          name="maxqm"
                                          v-model="projectsTableFilter.maxqm"
                                          :placeholder="$t('search.till')"
                                  />
                              </div>
                          </div>
                      </div>
                    <div class="filter__grid">
                      <div
                        class="filter__grid__item filter__grid__item--normal"
                      >
                        <div class="form-group">
                          <v-select-location
                            :placeholder="$t('search.location')"
                            class="form-control--small"
                            v-model="projectsTableFilter.location_id"
                            :customerId="$route.params.customer"
                          />
                        </div>
                      </div>
                      <div
                        class="filter__grid__item filter__grid__item--normal"
                      >
                        <div class="form-group">
                          <v-select-user
                            :placeholder="$t('search.pm')"
                            class="form-control--small"
                            :userType="$helpers.usertypes.pm"
                            :customerId="$route.params.customer"
                            v-model="projectsTableFilter.account_id"
                          />
                        </div>
                      </div>
                      <div
                        class="filter__grid__item filter__grid__item--normal"
                      >
                        <div class="form-group">
                          <v-datepicker
                            class="form-control form-control--small form-control--date"
                            :placeholder="$t('search.from')"
                            :format="
                              $t('search.from') + ' ' + $helpers.dateFormat
                            "
                            v-model="projectsTableFilter.from"
                            :disabledDates="{
                              days: [6, 0],
                              from: new Date(projectsTableFilter.till),
                            }"
                            :clearButton="true"
                            :language="de"
                            :monday-first="true"
                          />
                        </div>
                      </div>
                      <div
                        class="filter__grid__item filter__grid__item--normal"
                      >
                        <div class="form-group">
                          <v-datepicker
                            class="form-control form-control--small form-control--date"
                            :placeholder="$t('search.till')"
                            :format="
                              $t('search.till') + ' ' + $helpers.dateFormat
                            "
                            v-model="projectsTableFilter.till"
                            :disabledDates="{
                              days: [6, 0],
                              to: new Date(projectsTableFilter.from),
                            }"
                            :clearButton="true"
                            :language="de"
                            :monday-first="true"
                          />
                        </div>
                      </div>
                      <div
                        class="filter__grid__item filter__grid__item--normal"
                      >
                        <div class="form-group">
                          <v-select-status
                            :placeholder="$t('search.status')"
                            class="form-control--small"
                            v-model="projectsTableFilter.status"
                            :prependedOptions="prependedStatusOptions"
                          />
                        </div>
                      </div>
                      <div class="filter__grid__item filter__grid__item--large">
                        <div class="form-group form-group--search">
                          <input
                            type="text"
                            class="form-control form-control--small form-control--search"
                            :placeholder="$t('search.term')"
                            v-model="projectsTableFilter.search"
                          />
                          <button
                            role="button"
                            type="submit"
                            class="button button--full-width"
                            :title="$t('search')"
                          >
                            {{ $t("search") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>

                  <v-table
                    :isLoading="projectsTableLoading"
                    :columns="projectsTableColumns"
                    :items="projectsTableItems"
                    :showShowAll="false"
                    :useDetailRow="true"
                  >
                    <template slot="deadline" slot-scope="{ row }">
                      <span class="table-date">
                        {{ row.createdon.date | moment("DD") }}
                        <span>{{ row.createdon.date | moment("MMM") }}</span>
                      </span>
                      <template v-if="$store.getters.userIsAdmin">
                        <div
                          :title="$t('project.error.nogeolocation')"
                          v-if="!row.lat || !row.lon"
                        >
                          <svg
                            class="u-icon--geolocation-warning"
                            role="presentation"
                          >
                            <use
                              xlink:href="/dist/sprite.svg#icon-globe"
                              href="/dist/sprite.svg#icon-globe"
                            />
                          </svg>
                        </div>
                      </template>
                    </template>
                    <template slot="address" slot-scope="{ row }">
                      <span class="table-label">{{ row.project_number }}</span>
                      <span class="table-description"
                        >{{ row.address.zipcode }} {{ row.address.city }},
                        {{ row.address.street }}
                        {{ row.address.housenumber }}</span
                      >
                      <span
                        v-if="row.requested_deadline"
                        class="table-description table-description--normal"
                      >
                        Wunschtermin: {{ row.requested_deadline }}
                      </span>
                      <template v-if="row.tour_routes">
                        <div
                          v-for="(route, index) in row.tour_routes"
                          :key="index"
                          style="white-space: nowrap"
                        >
                          <svg class="u-icon--announcement" role="presentation">
                            <use
                              xlink:href="/dist/sprite.svg#icon-announcement"
                              href="/dist/sprite.svg#icon-announcement"
                            />
                          </svg>
                          <small>
                            <strong
                              >{{ $t("tours.expecteddate") }}
                              {{ $t("tours.from") }}
                              {{ route.tour_startdate | moment("DD.MM.YYYY") }}
                              {{ $t("tours.till") }}
                              {{ route.tour_enddate | moment("DD.MM.YYYY")}}
                              | Kol. {{ route.kolonne }}
                              </strong
                            >
                          </small>
                        </div>
                      </template>

                      <template v-if="row.weekplan_entries">
                        <div
                          v-for="(entry, index) in row.weekplan_entries"
                          :key="index"
                        >
                          <svg class="u-icon--announcement" role="presentation">
                            <use
                              xlink:href="/dist/sprite.svg#icon-announcement"
                              href="/dist/sprite.svg#icon-announcement"
                            />
                          </svg>
                          <small>
                            <strong
                              >{{ $t("tours.expecteddate") }}
                              {{ entry.startdate | moment("DD.MM.YYYY") }}
                              | Kol. {{ entry.kolonne }}
                              </strong
                            >
                          </small>
                        </div>
                      </template>
                    </template>
                    <template slot="location" slot-scope="{ row }">
                      <span class="table-label">{{
                        row.location.company_name
                      }}</span>
                      <span class="table-description">{{
                        $t("form.project.location")
                      }}</span>
                    </template>
                    <template slot="project_manager" slot-scope="{ row }">
                      <span class="table-label"
                        >{{ row.account.profile.firstname }}
                        {{ row.account.profile.lastname }}</span
                      >
                      <span class="table-description">{{
                        $t("form.project.pm")
                      }}</span>
                    </template>
                    <template slot="qm" slot-scope="{ row }">
                      <span class="table-status table-status--right">
                        <template
                          v-if="
                            $store.getters.userHasPermission(
                              'project_update_status'
                            )
                          "
                        >
                          <div
                            v-if="
                              ['open', 'pending'].indexOf(row.status) !== -1
                            "
                            role="button"
                            class="status-icon"
                            :class="'status-icon--' + row.status"
                            :title="$t('status.' + row.status + '_short')"
                          >
                            {{ $t("status." + row.status + "_short") }}
                          </div>
                          <span
                            v-else
                            class="status-icon"
                            :class="'status-icon--' + row.status"
                            >{{ $t("status." + row.status + "_short") }}</span
                          >
                        </template>
                        <template v-else>
                          <span
                            class="status-icon"
                            :class="'status-icon--' + row.status"
                            >{{ $t("status." + row.status + "_short") }}</span
                          >
                        </template>
                        <span class="table-label">
                          {{ $helpers.formatNumber(row.stats.qm.open) }}
                          <span class="u-text-small u-text-normal"
                            >/
                            {{
                              $helpers.formatNumber(row.stats.qm.total)
                            }}</span
                          >
                        </span>
                        <span class="table-description">{{ $t("qm") }}</span>
                      </span>
                    </template>
                    <template slot="status" slot-scope="{ row }">
                      <span class="table-label">{{
                        $t("status." + row.status + "_short")
                      }}</span>
                      <span class="table-description">{{ $t("status") }}</span>
                      <template v-if="row.status == 'cancelled'">
                        <small>{{
                          row.modifiedon.date
                            | moment($helpers.dateFormat.toUpperCase())
                        }}</small>
                      </template>
                    </template>
                    <template slot="media" slot-scope="{ row }">
                      <template
                        v-if="
                          $store.getters.userHasPermission(
                            'project_media_list'
                          ) && row.uploads.length >= 1
                        "
                      >
                        <router-link
                          :to="{
                            name: 'customers-view-customer-project-media',
                            params: {
                              customer: $route.params.customer,
                              project: row.id,
                            },
                          }"
                          class="button button--action button--action--files button--small"
                          :title="$t('media')"
                          >{{ $t("media") }}</router-link
                        >
                      </template>
                    </template>
                    <template slot="duplicate" slot-scope="{ row }">
                      <template
                        v-if="
                          $store.getters.userHasPermission('project_create')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'customers-duplicate-customer-project',
                            params: {
                              customer: $route.params.customer,
                              project: row.id,
                            },
                          }"
                          class="button button--action button--action--duplicate button--small"
                          :title="$t('duplicate')"
                          >{{ $t("duplicate") }}</router-link
                        >
                      </template>
                    </template>
                    <template slot="update" slot-scope="{ row }">
                      <template
                        v-if="
                          $store.getters.userHasPermission('project_update')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'customers-update-customer-project',
                            params: {
                              customer: $route.params.customer,
                              project: row.id,
                            },
                          }"
                          class="button button--action button--action--edit button--small"
                          :title="$t('update')"
                          >{{ $t("update") }}</router-link
                        >
                      </template>
                    </template>
                    <template v-slot:pdf="{ row }" v-if="$store.getters.userIsAdmin">
                        <button
                            class="button button--action button--action--pdf button--small"
                            type="button"
                            :value="row.project_number"
                            :title="$t('generatepdf')"
                            @click="onPdfCreate(row.id)"
                        >
                        {{ $t('generatepdf') }}
                        </button>
                    </template>
                    <template slot="detail-row" slot-scope="{ row }">
                      <v-projects-table-detail-row
                        v-model="row"
                        @update="onChangeProjectObject"
                      />
                    </template>
                  </v-table>
                  <v-pagination
                    :currentPage="projectsTableCurrentPage"
                    :itemsPerPage="projectsTableItemsPerPage"
                    :items="projectsTableItemsCount"
                    @pageClicked="onChangeProjectsTablePage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "../../partials/PageHeader";
import PageLoading from "../../partials/PageLoading.vue";
import ActionButtons from "./../../partials/Foundation/ActionButtons";

import Navigation from "./../Navigation";

import Table from "./../../partials/Foundation/Table";
import Pagination from "./../../partials/Foundation/Pagination";

import ProjectsTableDetailRow from "./ProjectsTableDetailRow";
import SelectUser from "./../../partials/Forms/SelectUser";
import SelectLocation from "./../../partials/Forms/SelectLocation";
import SelectStatus from "./../../partials/Forms/SelectStatus";
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";

export default {
  data() {
    return {
      de: de,
      loading: false,
      loadingError: null,
      customerObject: {
        id: 0,
      },
      prependedStatusOptions: [
        {
          id: "open,busy",
          title: this.$t("status.open_busy"),
        },
      ],
      projectsTableLoading: true,
      projectsTableColumns: [
        {
          key: "deadline",
        },
        {
          key: "address",
        },
        {
          key: "location",
          class: "show-for-xxlarge",
        },
        {
          key: "project_manager",
          class: "show-for-xxlarge",
        },
        {
          key: "qm",
          width: "115px",
          formatter: function (value, row) {
            var output = 0;
            if (row.layers.length > 0) {
              row.layers.forEach(function (layer) {
                output += layer.qm;
              });
            }
            return output;
          },
        },
        {
          key: "status",
          width: "115px",
        },
        {
          key: "media",
          width: "46px",
        },
        {
          key: "duplicate",
          width: "46px",
        },
        {
          key: "update",
          width: "46px",
        },
        {
          key: "pdf",
          width: "46px",
        }
      ],
      projectsTableCurrentPage: 1,
      projectsTableItemsPerPage: 20,
      projectsTableCurrentPage: this.$route.query.page || 1,
      projectsTableItemsPerPage: 20,
      projectsTableItems: [],
      projectsTableItemsCount: 0,
      projectsTableFilter: {
        location_id: this.$route.query.location_id || "",
        account_id: this.$route.query.account_id || "",
        status: this.$route.query.status || "open,busy",
        from: this.$route.query.from || "",
        till: this.$route.query.till || "",
        search: this.$route.query.search || "",
        minqm: this.$route.query.minqm || "",
        maxqm: this.$route.query.maxqm || ""
      },
      isCalculatingTotalQm: false,
      projectsTotalQm: 0,
      projectsTotalOpenQm: 0,
    };
  },
  components: {
    PageLoading,
    vPageHeader: PageHeader,
    vActionButtons: ActionButtons,
    vNavigation: Navigation,
    vTable: Table,
    vPagination: Pagination,
    vSelectUser: SelectUser,
    vSelectLocation: SelectLocation,
    vSelectStatus: SelectStatus,
    vDatepicker: Datepicker,
    vProjectsTableDetailRow: ProjectsTableDetailRow,
  },
  computed: {
    isLoading: function () {
      return this.loading;
    },
    hasLoadingError: function () {
      return this.loadingError !== null;
    },
    getPageTile: function () {
      if (this.customerObject.company_name) {
        return this.customerObject.company_name;
      }

      return this.$t("projects.title");
    },
    getActionButtons: function () {
      let buttons = [];

      if (this.$store.getters.userHasPermission("project_create")) {
        buttons.push({
          action: "create-new",
          router: {
            name: "customers-create-customer-project",
            params: { custumor: this.$route.params.customer },
          },
        });
      }

      return buttons;
    },
  },
  created: function () {
    this.onUpdateCustomer();
  },
  methods: {
    onPdfCreate: function (id) {
        let promise = this.$api.clearParams()
            .get(`/projects/${id}/pdf`);

        promise.then((response => {
            const pdfs = response.data.data;
            console.log(pdfs);
            pdfs.forEach(pdf => {
                window.open(pdf.url, '_blank');
            })
        }).bind(this)).catch((error => {
            console.error('Fehler beim Abrufen der PDFs:', error);
        }).bind(this));
    },

    onUpdateCustomer: function () {
      this.loadingError = null;

      if (!this.$route.params.customer) {
        this.onUpdateProjectsTableItems();
      } else {
        let promise = this.$api
          .clearParams()
          .get("customers/" + this.$route.params.customer + "/get");

        promise
          .then(
            ((response) => {
              this.customerObject = response.data.data;

              this.onUpdateProjectsTableItems(true);
            }).bind(this)
          )
          .catch(
            ((error) => {
              this.loadingError = error.response.data.message;
            }).bind(this)
          )
          .finally(
            (() => {
              this.loading = false;
            }).bind(this)
          );

        this.loading = true;
      }
    },
    onUpdateFilterParameters: function () {
      let query = {
        page: this.projectsTableCurrentPage,
      };

      for (let key in this.projectsTableFilter) {
        if (this.projectsTableFilter[key]) {
          if (key === "from" || key === "till") {
            query[key] = this.formatDate(this.projectsTableFilter[key]);
          } else {
            query[key] = this.projectsTableFilter[key];
          }
        }
      }

      this.$helpers.pushQuery(this.$router, this.$route.query, query);
    },
    onChangeProjectsTablePage: function (page) {
      this.projectsTableCurrentPage = page;

      this.onUpdateProjectsTableItems();
    },
    onChangeProjectsTableFilter: function (event) {
      event.preventDefault();

      this.projectsTableCurrentPage = 1;

      this.onUpdateProjectsTableItems();
    },
    onUpdateProjectsTableItems: function (firstUpdate) {
      if (!firstUpdate) {
        this.onUpdateFilterParameters();
      }

      let promise = this.$api
        .clearParams()
        .addParam("customer_id", this.$route.params.customer)
        .addParam("location_id", this.projectsTableFilter.location_id)
        .addParam("account_id", this.projectsTableFilter.account_id)
        .addParam("status", this.projectsTableFilter.status)
        .addParam("from", this.formatDate(this.projectsTableFilter.from))
        .addParam("till", this.formatDate(this.projectsTableFilter.till))
        .addParam("search", this.projectsTableFilter.search)
        .addParam("minqm", this.projectsTableFilter.minqm)
        .addParam("maxqm", this.projectsTableFilter.maxqm)
        .setPageParams(
          this.projectsTableCurrentPage,
          this.projectsTableItemsPerPage
        )
        .setSortParams("createdon", "desc")
        .get("projects");

      promise
        .then(
          ((response) => {
            this.projectsTableItems = response.data.data;
            this.projectsTableItemsCount = response.data.meta.pagination.total;

            this.projectsTableLoading = false;
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.projectsTableItems = [];
            this.projectsTableItemsCount = 0;

            this.projectsTableLoading = false;
          }).bind(this)
        );

      this.projectsTableLoading = true;

      this.onUpdateProjectsTotalOpenQm();
    },

    onChangeProjectObject: function (object) {
      this.onUpdateProjectsTableItems();
    },

    onUpdateProjectsTotalOpenQm: function () {
      this.isCalculatingTotalQm = true

      this.$api
        .clearParams()
        .addParam("show_all", this.projectsTableFilter.show_all)
        .addParam("customer_id", this.$route.params.customer)
        .addParam("location_id", this.projectsTableFilter.location_id)
        .addParam("account_id", this.projectsTableFilter.account_id)
        .addParam("status", this.projectsTableFilter.status)
        .addParam("from", this.formatDate(this.projectsTableFilter.from))
        .addParam("till", this.formatDate(this.projectsTableFilter.till))
        .addParam("search", this.projectsTableFilter.search)
        .addParam("minqm", this.projectsTableFilter.minqm)
        .addParam("maxqm", this.projectsTableFilter.maxqm)
        .get("projects")
        .then(response => {
          this.projectsTotalQm = 0;
          this.projectsTotalOpenQm = 0;

          response.data.data
            .filter(row => row.layers.length > 0)
            .forEach(row => {
              row.layers.forEach(layer => {
                this.projectsTotalQm += parseInt(layer.qm);

                if (row.status != "cancelled") {
                  this.projectsTotalOpenQm += parseInt(layer.qm);

                  if (!["finished", "finished_manual"].includes(layer.status)) {
                    layer.layer_logs.forEach(layerlog => {
                      this.projectsTotalOpenQm -= parseInt(layerlog.qm);
                    });
                  } else {
                    this.projectsTotalOpenQm -= parseInt(layer.qm);
                  }
                }
              });
            });
        })
        .catch(error => {
          console.error('Failed to fetch projects to calculate total square meters', error)
        })
        .finally(() => {
          this.isCalculatingTotalQm = false
        });
    },
    formatDate: function (date) {
      if (date === "" || date === null || date === undefined) {
        return "";
      }

      return this.$moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
